import { LoadState } from "@redotech/react-util/load";
import { Tag } from "@redotech/redo-common-model-tags-common/tag";
import { fgColumnEntries } from "@redotech/redo-fulfillment-common/views/fulfillment/fg-column-catalog";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { FulfillmentGroupUpdate } from "@redotech/redo-merchant-fulfillment-rpc/schema/update-fulfillment-groups";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";
import { TagsCell } from "../cells/tags-cell";

const catalogEntry = fgColumnEntries.tag;

export const ShipmentTagsColumn = ({
  availableTagsLoad,
  getAvailableTags,
  updateRowData,
}: {
  availableTagsLoad: LoadState<Tag[] | undefined>;
  getAvailableTags: (signal?: AbortSignal) => void;
  updateRowData: (rowUpdates: FulfillmentGroupUpdate[]) => void;
}): Column2<FulfillmentGroupData> => ({
  alignment: ColumnAlignment.LEFT,
  key: catalogEntry.key,
  title: catalogEntry.title,
  renderNormalCell: ({ row }) => {
    return (
      <TagsCell
        availableTagsLoad={availableTagsLoad}
        getAvailableTags={getAvailableTags}
        rowData={row}
        updateRowData={updateRowData}
      />
    );
  },
  sort: catalogEntry.sortDirection,
  width: catalogEntry.defaultWidth,
});
